require('whatwg-fetch');

const { registerLinkResolver } = require('@prismicio/gatsby-source-prismic-graphql');
const { linkResolver } = require('./src/utils/link');
 
registerLinkResolver(linkResolver);

exports.onClientEntry = () => {
  // Don't need to do anything here, but if you don't
  // export something, the import won't work.
}

exports.onRouteUpdate = ({ location, prevLocation }) => {
	// document.body.style.overflow = "visible";


}

exports.onRouteUpdate = ({ location, prevLocation }) => {
	const html = document.querySelector('html')
	html.style.overflow = 'visible';
}